
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creatoriq-alternative",
      function () {
        return require("private-next-pages/creatoriq-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creatoriq-alternative"])
      });
    }
  